"use client";
import React, { useEffect, useState } from "react";
import { useBilling } from "../../../../../context/BillingContext";
import {
  CurrentPlanProtag,
  CurrentplanSkeleton,
} from "../../../../StaticPages/Pages/Skeleton/CurrentplanSkeleton";
import { useRazorpay } from "../../../../../context/RazorpayContext";
import formatDate from "../../../../../common/DateFormate";
import { rocket, rocket2 } from "../../../../../../images/index.js";
import { Link } from "react-router-dom";

const CurrentPlanCard = ({ openModal, openConfirmationModal }) => {
  const { currentPlan, loading, refetchBilling, cancelDowngrade, refetchPaymentMethods } =
    useBilling();
  const {
    handleCreatePlan,
    handlePreviewPlan,
    invoiceModalData,
    setInvoiceModalData,
    continueToPayment
  } = useRazorpay();

  const [isLoading, setIsLoading] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [loadings, setLoadings] = useState(false);

  // envent listner whenever plan is upgrade

  useEffect(() => {
    const handleBillingUpdate = () => {
      refetchBilling(); // current plan refresh
    };

    window.addEventListener("billingUpdated", handleBillingUpdate);

    return () => {
      window.removeEventListener("billingUpdated", handleBillingUpdate);
    };
  }, []);

  const handleCancelDowngrade = async () => {
    try {
      setLoadings(true);

      const res = await cancelDowngrade();

      if (res?.success) {
        refetchBilling(); // important
        setActiveModal(null);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadings(false);
    }
  };
  const formattedDescription = currentPlan?.description
    ?.replace(/\\u003c/g, "<")
    ?.replace(/\\u003e/g, ">");
  // ?.replace(/\n/g, "<br/>");
  const descriptionPoints = formattedDescription
    ?.split("\n")
    ?.filter((line) => line.trim() !== "");

  const handleRegeneratePaymentUrl = async (e) => {
    handlePreviewPlan(e, currentPlan?.id, "plan", false);
    // await handleCreatePlan(e, setIsLoading, 'generatePaymentUrl',null, refetchBilling)
  };

  const hasDowngrade =
    currentPlan?.subscription?.plan_changes &&
    Object.keys(currentPlan.subscription.plan_changes).length > 0;

  return (
    <>
      <div
        className={`current-plan-card h-100 w-100 ${hasDowngrade ? "is-downgrading" : ""}`}
      >
        <img src={rocket2} className="rocket-bg" />
        {/* HEADER */}
        <div className="plan-header">
          <h5 className="plan-title text-capitalize">{currentPlan?.name || "Growth Plan"}</h5>
          {hasDowngrade && (
            <span className="downgrade-header-badge">{currentPlan?.subscription?.plan_changes?.downgrade ? <> Downgrading </> : <>Upgrading</>}</span>
          )}
        </div>

        {/* BODY */}
        <div className="plan-body">
          {loading?.currentPlan ? (
            <CurrentplanSkeleton />
          ) : (
            <>
              {/* PRICE */}
              <div className="plan-price-wrapper d-flex flex-column gap-1">
                <div className="plan-price">
                  {currentPlan?.is_free ? (
                    <span>{currentPlan?.trial?.days} Days Free Trial</span>
                  ) : (
                    <>
                      {currentPlan?.subscription?.subscription_amount || "₹---"}
                      <span className="plan-duration">
                        /{currentPlan?.subscription?.interval || "month"}
                      </span>
                    </>
                  )}
                </div>
                {/* DESCRIPTION */}
                {currentPlan?.subscription?.billing_cycle && (
                  <div className="plan-meta" >
                    {!currentPlan?.is_free ? <>Billing Cycle </> : <>Free Till </>} : {currentPlan?.subscription?.billing_cycle}
                  </div>
                )}
              </div>

              {hasDowngrade && (
                <div className="downgrade-message-alert">
                  <i className="bi bi-info-circle-fill"></i>

                  <div className="downgrade-message-content">
                    <span className="downgrade-message-title">
                      {currentPlan?.subscription?.plan_changes?.label}:{" "}
                      {currentPlan?.subscription?.plan_changes?.name} (
                      {currentPlan?.subscription?.plan_changes?.interval})
                    </span>

                    <span className="downgrade-message-text">
                      {currentPlan?.subscription?.plan_changes?.message}
                    </span>
                  </div>
                </div>
              )}

              {!loading?.currentPlan &&
                (currentPlan?.subscription?.status === "suspended" ? (
                  <button
                    className="plan-btn"
                    onClick={handleRegeneratePaymentUrl}
                  >
                    {isLoading ? "Loading..." : <><i className="bi bi-rocket-takeoff me-1"></i> Continue Payment</>}
                  </button>
                ) : hasDowngrade ? (
                  currentPlan?.subscription?.plan_changes?.downgrade ? (
                    <button
                      className="btn-cancel-downgrade"
                      onClick={openConfirmationModal}
                    >
                      Cancel Downgrade
                    </button>
                  ) : currentPlan?.subscription?.plan_changes?.payment_link ? (
                    <div
                      onClick={(e) => continueToPayment(e,currentPlan) }
                      className="plan-btn d-flex align-items-center justify-content-center text-decoration-none"
                    >
                      <i className="bi bi-rocket-takeoff me-1"></i>
                      Continue Payment
                    </div>
                  ) : null
                ) : (
                  <button
                    className="plan-btn"
                    onClick={() => openModal("upgrade")}
                    style={{ width: "50%" }}
                  >
                    Update Plan
                  </button>
                ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CurrentPlanCard;
